import React from "react";
import { ReactComponent as Loader } from "../../../../assets/loading_icon.svg";

export const LoadingState = ({ title = "Загрузка..." }: { title?: string }) => {
    return (
        <div className="min-h-[60vh] w-full flex flex-col items-center justify-center gap-3 px-4">
            <div className="w-24 h-24 flex items-center justify-center opacity-80">
                <Loader fill="#818C99" stroke="#818C99" className="w-full h-full" />
            </div>
            <div className="text-base font-medium text-slate-600">{title}</div>
        </div>
    );
};
